import { render } from "./ProductionReceivedReport.vue?vue&type=template&id=4c28ca47&scoped=true"
import script from "./ProductionReceivedReport.vue?vue&type=script&lang=js"
export * from "./ProductionReceivedReport.vue?vue&type=script&lang=js"

import "./ProductionReceivedReport.vue?vue&type=style&index=0&id=4c28ca47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c28ca47"]])

export default __exports__